import { TestVariantNames } from "src/features/homePageABCTest/common/enums";
import {
  LanguageIsoCode,
  UtmParams,
} from "src/features/homePageABCTest/imports";

export const generateHomePageABCTestVariant = (
  locale: LanguageIsoCode,
  chances: number[]
): TestVariantNames => {
  const url = new URL(window.location.href);
  const hasUtmMedium = url.searchParams.has(UtmParams.UTM_MEDIUM);
  const hasUtmCampaign = url.searchParams.has(UtmParams.UTM_CAMPAIGN);

  if (hasUtmMedium || hasUtmCampaign || locale !== "en") {
    return TestVariantNames.NONE;
  }

  const [nonFlirtyChance, flirtyWithStreamersChance, flirtyChance] = chances;
  const randomPercent = Math.random() * 100;

  if (randomPercent < nonFlirtyChance) {
    return TestVariantNames.NON_FLIRTY;
  }
  if (randomPercent < nonFlirtyChance + flirtyWithStreamersChance) {
    return TestVariantNames.FLIRTY_WITH_STREAMERS;
  }
  if (
    randomPercent <
    nonFlirtyChance + flirtyWithStreamersChance + flirtyChance
  ) {
    return TestVariantNames.FLIRTY;
  }

  return TestVariantNames.DEFAULT;
};
